<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48">
  <path d="M0 0h48v48H0z" fill="none" />
  <g fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="4">
    <path d="M44 14L24 4L4 14v20l20 10l20-10z" />
    <path stroke-linecap="round" d="m4 14l20 10m0 20V24m20-10L24 24M34 9L14 19" />
  </g>
</svg>
